import React from 'react';
import { X, AlertTriangle, RotateCcw, Shield } from 'lucide-react';
import { Button, Badge } from '../../common';

const ResetConfirmationModal = ({ conversation, onConfirm, onClose }) => {
  // Extrair nome do cliente (PRIORIDADE: context.nome)
  const clientName = conversation?.context?.nome || 
                     conversation?.context?.name ||
                     conversation?.lead?.name || 
                     conversation?.profile_name || 
                     'Cliente';

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full animate-scale-in">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-6 h-6 text-orange-600" />
            </div>
            <div>
              <div className="flex items-center gap-2">
                <h2 className="text-xl font-bold text-gray-900">
                  Resetar Conversa
                </h2>
                <Badge variant="primary" size="sm" icon={<Shield className="w-3 h-3" />}>
                  Admin
                </Badge>
              </div>
              <p className="text-sm text-gray-600">{clientName}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6">
          <div className="space-y-4">
            <div className="p-4 bg-orange-50 border border-orange-200 rounded-lg">
              <p className="text-sm font-semibold text-orange-900 mb-2">
                ⚠️ Esta ação não pode ser desfeita!
              </p>
              <p className="text-sm text-orange-800">
                Resetar a conversa irá apagar todo o histórico e reiniciar o fluxo.
              </p>
            </div>

            <div className="space-y-3">
              <h3 className="font-semibold text-gray-900 text-sm">
                O que acontecerá:
              </h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-red-600 text-xs">✕</span>
                  </div>
                  <span>Todo o histórico de mensagens será apagado</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-red-600 text-xs">✕</span>
                  </div>
                  <span>Variáveis e contexto da conversa serão perdidos</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-green-600 text-xs">✓</span>
                  </div>
                  <span>O fluxo reiniciará do zero (mensagem de boas-vindas)</span>
                </li>
                <li className="flex items-start gap-2">
                  <div className="w-5 h-5 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5">
                    <span className="text-green-600 text-xs">✓</span>
                  </div>
                  <span>Cliente receberá a mensagem inicial automaticamente</span>
                </li>
              </ul>
            </div>

            <div className="p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-sm text-blue-800">
                💡 <strong>Dica:</strong> Se você quer apenas pausar temporariamente, 
                use o botão "Pausar Bot" ao invés de resetar.
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end gap-3 p-6 border-t border-gray-200 bg-gray-50">
          <Button
            variant="outline"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              onConfirm();
              onClose();
            }}
            leftIcon={<RotateCcw className="w-4 h-4" />}
            className="bg-orange-500 hover:bg-orange-600 focus:ring-orange-400"
          >
            Sim, Resetar Conversa
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResetConfirmationModal;